import React from 'react'
import {translate} from 'react-i18next'
import Helmet from 'react-helmet'
import Header from '../components/Header.js'
import PrettyDate from '../components/PrettyDate.js'
import image1 from '../images/news/1.jpg'

export const news = [
  {
    publishedAt: new Date('2019/01/01'),
    catch: image1,
    href: '/news/2019/01/01',
    title: 't1',
    description: 'd1'
  }
]

const NewsLink = ({news, t}) => (
  <div className="news-link">
    <a className="news-photo" style={ {backgroundImage: `url(${news.catch})`} } href={news.href} />
    <div className="news-link-wrapper">
      <div className="news-link-date">
        <PrettyDate date={news.publishedAt} />
      </div>
      <div className="news-link-title">{t(news.title)}</div>
      <div className="news-link-splitter"></div>
      <div className="news-link-desc">{t(news.description)}</div>
      <div className="news-link-more">
        <a href={news.href}>READ MORE</a>
      </div>
    </div>
  </div>
)

const News = translate('news')(
  ({t}) => (
    <div id="news">
      <Header current="news" />
      <div className="container">
        <div className="col1 col-pad1">
          <h1 className="page-title">News</h1>
        </div>
        <div className="col3 news-list">
          {
            news.map(news => <NewsLink key={news.href} news={news} t={t} />)
          }
        </div>
      </div>
    </div>
  )
)

export default () => (
  <div>
    <Helmet
      meta={[
        {name: 'description', content: 'Babels News'},
        {property: 'og:title', content: 'Babels News'},
        {property: 'og:url', content: 'https://babels.co/news'},
        {property: 'og:image', content: 'https://dummyimage.com/600x400/000/fff'},
        {property: 'og:image:width', content: '600'},
        {property: 'og:image:height', content: '400'},
        {property: 'og:description', content: 'Babels News'},
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:site', content: '@null'},
        {name: 'twitter:creator', content: '@null'}
      ]}
    />
    <News />
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/news.js